module.exports = __webpack_public_path__ + "d497870afb720d6f143cfdfc41ca88e9.svg";